import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import $ from 'jquery';

const timers = new WeakMap();

function submitGrid(form) {
  if (form) Rails.fire(form, 'submit');
}

function applyColumns(grid) {
  const hidden = Array.from(grid.querySelectorAll('.dashboard-deal-column-toggle:not(:checked)')).map(input => input.value);
  grid.querySelectorAll('[data-dashboard-column]').forEach(cell => {
    cell.classList.toggle('d-none', hidden.includes(cell.dataset.dashboardColumn));
  });
}

$(document).on('input', '.dashboard-deal-filters input[type="search"]', function() {
  const form = this.form;
  clearTimeout(timers.get(form));
  timers.set(form, setTimeout(() => submitGrid(form), 300));
});

$(document).on('change', '.dashboard-deal-filters select, .dashboard-deal-per-page', function() {
  submitGrid(this.form || document.getElementById(this.getAttribute('form')));
});

$(document).on('click', '.dashboard-deal-sort', function() {
  const grid = this.closest('.dashboard-deal-grid');
  const form = grid && grid.querySelector('.dashboard-deal-filters');
  if (!form) return;
  form.querySelector('[name="sort_column"]').value = this.dataset.sortColumn;
  form.querySelector('[name="sort_direction"]').value = this.dataset.sortDirection;
  submitGrid(form);
});

$(document).on('change', '.dashboard-deal-column-toggle', function() {
  const grid = this.closest('.dashboard-deal-grid');
  if (!grid) return;
  document.querySelectorAll('.dashboard-deal-grid').forEach(otherGrid => {
    otherGrid.querySelectorAll('.dashboard-deal-column-toggle').forEach(input => {
      if (input.value === this.value) input.checked = this.checked;
    });
    applyColumns(otherGrid);
  });
  Rails.ajax({
    type: 'PATCH',
    url: grid.dataset.columnUpdateUrl,
    data: new URLSearchParams({ column_key: this.value, visible: this.checked ? 'true' : 'false' }).toString(),
    error: () => {
      const restored = !this.checked;
      document.querySelectorAll('.dashboard-deal-grid').forEach(otherGrid => {
        otherGrid.querySelectorAll('.dashboard-deal-column-toggle').forEach(input => {
          if (input.value === this.value) input.checked = restored;
        });
        applyColumns(otherGrid);
      });
    }
  });
});

$(document).on('click', '.dashboard-deal-columns-menu', function(event) {
  event.stopPropagation();
});

const activeTripCollapseSelector = [
  '.travelers-active-deals .traveler-trip-deals-collapse',
  '.travelers-purchase-active-deals .traveler-trip-deals-collapse',
  '.forwarder-active-deals .forwarder-trip-deals-collapse',
  '.forwarder-purchase-active-deals .forwarder-trip-deals-collapse'
].join(', ');

function scrollActiveTripToTop(collapse, correctPosition = false) {
  if (!window.matchMedia('(max-width: 767.98px)').matches) return;
  const detailRow = collapse.closest('tr.hiddenRowWrap');
  const tripRow = detailRow && detailRow.previousElementSibling;
  if (!tripRow || !tripRow.classList.contains('dashboard-accordion-row')) return;

  const navbar = document.querySelector('header .navbar.fixed-top');
  const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 0;
  const top = Math.max(0, window.scrollY + tripRow.getBoundingClientRect().top - navbarHeight - 12);
  if (correctPosition && Math.abs(top - window.scrollY) < 32) return;
  window.scrollTo({
    top,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  });
}

$(document).on('show.bs.collapse', activeTripCollapseSelector, function() {
  const collapse = this;
  setTimeout(() => scrollActiveTripToTop(collapse), 0);
});

$(document).on('shown.bs.collapse', activeTripCollapseSelector, function() {
  const collapse = this;
  setTimeout(() => scrollActiveTripToTop(collapse, true), 0);
});

$(document).on('click', '.dashboard-deal-row', function(event) {
  if (event.target.closest('a, button, input, select, textarea, label, [role="button"], [contenteditable="true"]')) return;
  Turbolinks.visit(this.dataset.orderUrl);
});

$(document).on('click', '.dashboard-deal-photo-trigger', function(event) {
  event.preventDefault();
  event.stopPropagation();
  const template = document.getElementById(this.dataset.photoTemplate);
  if (!template) return;
  const modal = $(template.content.firstElementChild.cloneNode(true));
  modal.appendTo(document.body);
  modal.on('hidden.bs.modal', () => modal.remove());
  modal.modal('show');
});


$(document).on('click', '.dashboard-deal-gallery-thumb', function() {
  const gallery = this.closest('.dashboard-deal-gallery');
  if (!gallery) return;
  gallery.querySelectorAll('.dashboard-deal-gallery-thumb').forEach(thumb => {
    const active = thumb === this;
    thumb.classList.toggle('is-active', active);
    thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  const image = gallery.querySelector('.dashboard-deal-gallery-main');
  const label = gallery.querySelector('.dashboard-deal-gallery-label');
  const counter = gallery.querySelector('.dashboard-deal-gallery-counter');
  if (image) {
    image.src = this.dataset.photoUrl;
    image.alt = this.dataset.photoLabel;
  }
  if (label) label.textContent = this.dataset.photoLabel;
  if (counter) counter.textContent = `${this.dataset.photoNumber} of ${gallery.querySelectorAll('.dashboard-deal-gallery-thumb').length}`;
});
document.addEventListener('dashboard-deals:updated', event => {
  const results = document.getElementById(event.detail.gridId);
  const grid = results && results.closest('.dashboard-deal-grid');
  if (grid) applyColumns(grid);
});

$(document).on('turbolinks:load', function() {
  document.querySelectorAll('.dashboard-deal-grid').forEach(applyColumns);
});

$(document).on('ajax:complete', function() {
  document.querySelectorAll('.dashboard-deal-grid').forEach(applyColumns);
});
